module.exports = __webpack_public_path__ + "static/media/AboutUs-banner.ac55fe86.jpg";